import { createContext } from 'react';
import { UserType } from '../types';

export const UserContext = createContext({
  user: {} as UserType,
  setUser: (user: UserType) => {},
});
